/**
 * Imagini pentru știrile automate (news_posts).
 * Din 25.09.2026 afișăm doar imagini de pe domeniile noastre
 * (Supabase-ul proiectului, roautomarket.ro) sau Unsplash.
 * Valoarea og_image_url din baza de date NU se modifică; filtrarea e doar la afișare.
 */
export const DEFAULT_SITE_IMAGE = "https://roautomarket.ro/og-roautomarket.png";

const ALLOWED_HOSTS = [
  "ifphnacztbspsexaxssc.supabase.co",
  "roautomarket.ro",
  "www.roautomarket.ro",
  "images.unsplash.com",
  "unsplash.com",
  "plus.unsplash.com",
];

/** Returnează URL-ul absolut dacă imaginea e permisă, altfel null. */
export function allowedNewsImage(url?: string | null): string | null {
  if (!url) return null;
  if (url.startsWith("/") && !url.startsWith("//")) return `https://roautomarket.ro${url}`;
  try {
    const host = new URL(url).hostname.toLowerCase();
    return ALLOWED_HOSTS.includes(host) ? url : null;
  } catch {
    return null;
  }
}
